import { Btn, Logo, Footer, Card } from "./ui";
import { CLUB_BASE } from "./clubApi";

export default function TeamLogin() {
  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + `${CLUB_BASE}/team`;
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <div className="mx-auto max-w-md px-6 pt-16" data-testid="team-login">
      <div className="flex items-center gap-3"><Logo size={40} /><div><p className="font-club-display text-xl leading-none">Diamond Club</p><p className="text-[0.62rem] uppercase tracking-[0.25em] text-[#9A948A] mt-1">Area team</p></div></div>
      <h1 className="font-club-display text-4xl leading-[1.05] mt-12">I tuoi clienti, <span className="text-[#E5B13A]">seguiti davvero.</span></h1>
      <p className="mt-4 text-[#9A948A] leading-relaxed">Il tuo link personale per il test, i risultati dei tuoi clienti, il percorso da confermare e i messaggi già pronti per WhatsApp.</p>
      <Card className="mt-10">
        <Btn className="w-full" onClick={login} data-testid="google-login-btn">
          <svg width="18" height="18" viewBox="0 0 48 48"><path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9 3.5l6.7-6.7C35.6 2.6 30.2 0 24 0 14.6 0 6.5 5.4 2.6 13.3l7.8 6C12.3 13.6 17.7 9.5 24 9.5z"/><path fill="#4285F4" d="M46.5 24.5c0-1.6-.1-3.1-.4-4.5H24v9h12.7c-.6 3-2.3 5.5-4.8 7.2l7.5 5.8c4.4-4.1 7.1-10.1 7.1-17.5z"/><path fill="#FBBC05" d="M10.4 28.7c-.5-1.5-.8-3-.8-4.7s.3-3.2.8-4.7l-7.8-6C.9 16.5 0 20.1 0 24s.9 7.5 2.6 10.7l7.8-6z"/><path fill="#34A853" d="M24 48c6.2 0 11.6-2 15.4-5.6l-7.5-5.8c-2.1 1.4-4.8 2.3-7.9 2.3-6.3 0-11.7-4.1-13.6-9.8l-7.8 6C6.5 42.6 14.6 48 24 48z"/></svg>
          Entra con Google
        </Btn>
        <p className="mt-3 text-center text-xs text-[#6F6A62]">Riservato alle incaricate del Diamond Team.</p>
      </Card>
      <Footer />
    </div>
  );
}
